import css from './WalletExtraMobile.module.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import DataTestId from 'meta/dataTestId'
import { Dates } from 'utils/dates'

import Img from 'components/Media/Img'
import { useOnUpdate } from 'hooks/useOnUpdate'

import TicketDataFetcher from '../../BulkDataFetcher/TicketDataFetcher/TicketDataFetcher'
import { getExtraIconImageNameAccordingToPolicy } from '../WalletExtraDesktop/utils'
import ExtraCardsContainer from './ExtraCards'
import { WalletExtraMobileProps } from './WalletExtraMobileContainer'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/bundle'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

const WalletExtraMobile: React.FC<WalletExtraMobileProps> = (props) => {
  const { eventData, locationData, baseProps } = props
  const { walletEventData, isPastEvent, isUsable, eventActive, setIsThereAtLeastOne, onClick } = baseProps

  const { t } = useTranslation()

  const [showSwiper, setShowSwiper] = useState<boolean>(false)
  const [fetchBulkData, setFetchBulkData] = useState<boolean>(false)

  const selected = eventActive === eventData.id
  const hidden = eventActive !== null && eventActive !== eventData.id

  const date = new Date(eventData.dateEvent.date_tz)

  const isEventCurrentlyOpen =
    Dates.isAfter(new Date(), new Date(eventData.dateOpen.date_tz)) &&
    Dates.isBefore(new Date(), new Date(eventData.dateEnd.date_tz))

  useOnUpdate(() => {
    setShowSwiper(selected)
  }, [eventActive])

  useEffect(() => {
    if (showSwiper && !fetchBulkData) {
      setFetchBulkData(true)
    }
  }, [showSwiper])

  if (isUsable && !isEventCurrentlyOpen) {
    return null
  }

  if (!isUsable && !isPastEvent && isEventCurrentlyOpen) {
    return null
  }

  if (setIsThereAtLeastOne) {
    setIsThereAtLeastOne(true)
  }

  return (
    <>
      <div
        className={classNames(css.walletExtraMobile, {
          [css.selected]: selected,
          [css.hidden]: hidden,
          [css.isPastEvent]: isPastEvent,
          [css.isUsable]: isUsable,
        })}
        onClick={() => {
          if (!hidden) onClick(eventData.id)
        }}
        data-testid={`${DataTestId.wallet.extraEventMobile}-${eventData.id}`}
      >
        <div className={css.left}>
          <Img
            className={css.icon}
            src={`/wallet/goodsservices/${isPastEvent ? 'black' : 'purple'}/${getExtraIconImageNameAccordingToPolicy(eventData?.policy?.code)}.svg`}
          />

          <div className={css.details}>
            <div className={css.date}>{Dates.format(date, t('dates:common:square'))}</div>
            <h5 className={css.name}>{eventData.name}</h5>
          </div>
        </div>

        <div className={css.right}>
          {!selected && walletEventData.count > 1 && (
            <div className={css.count} data-testid={DataTestId.wallet.ticketCount}>
              {`x${walletEventData.count}`}
            </div>
          )}

          {selected && (
            <div className={css.closeBox}>
              <Img className={css.wave} src={`/wallet/wave_background.svg`} />
              <Img className={css.icon} src={`/wallet/extra_close_small.svg`} />
            </div>
          )}
        </div>
      </div>

      {fetchBulkData && <TicketDataFetcher eventId={eventData.id} />}

      {showSwiper && (
        <ExtraCardsContainer walletEventData={walletEventData} eventData={eventData} locationData={locationData} />
      )}
    </>
  )
}

export default WalletExtraMobile
